module.exports = __webpack_public_path__ + "media/src/images/logos/partners/rumah-4bea6160fe4f3b67f8b2bec4974d686f.png";